export interface IAd2cpQc {
    crit_const_pct_barocline:number,
    crit_const_pct_barotrope:number,
    crit_maxdepth_shear:number,
    crit_mindepth_shear:number,
    crit_nb_data_med:number,
    crit_nb_data_shear:number,
    crit_pitch:number,
    crit_rangedepth_shear:number,
    crit_roll:number,
    crit_shear_east_btm:number,
    crit_shear_east_top:number,
    crit_shear_north_btm:number,
    crit_shear_north_top:number,
    crit_speed_x:number,
    crit_speed_y:number,
    crit_speed_z:number,
    depth_noise:number,
    opti_pitch:number,
    opti_roll:number,
}


export const getDefaultAd2cpQc = ():IAd2cpQc => {
    return {
        crit_const_pct_barocline:5,
        crit_const_pct_barotrope:15,
        crit_maxdepth_shear:15,
        crit_mindepth_shear:15,
        crit_nb_data_med:2,
        crit_nb_data_shear:10,
        crit_pitch:20,
        crit_rangedepth_shear:10,
        crit_roll:20,
        crit_shear_east_btm:0.02,
        crit_shear_east_top:0.05,
        crit_shear_north_btm:0.02,
        crit_shear_north_top:0.05,
        crit_speed_x:0.75,
        crit_speed_y:0.75,
        crit_speed_z:0.75,
        depth_noise:100,
        opti_pitch:22.5,
        opti_roll:0
    }
}